module.exports = __webpack_public_path__ + "static/media/Skansen_Sweden_4.7e8847dd.jpg";